import { useTheme } from "@emotion/react";
import { Divider, Typography } from "@mui/material";
import React, { Fragment } from "react";

export const DontHaveAccount = ({ handleOpenSignUpDialog }) => {
  const theme = useTheme();
  return (
    <Fragment>
      <Divider />
      <Typography textAlign={'center'} fontWeight={500}>
        Don’t have an account? <span onClick={() => handleOpenSignUpDialog()} style={{ textDecoration: 'none', color: theme.palette.primary.main, cursor: 'pointer' }}>Sign Up</span>
      </Typography>
    </Fragment>
  );
}

export const AlreadyHaveAccount = ({ handleOpenLoginDialog }) => {
  const theme = useTheme();
  return (
    <Fragment>
      <Divider />
      <Typography textAlign={'center'} fontWeight={500}>
        Already have an account? <span onClick={() => handleOpenLoginDialog()} style={{ textDecoration: 'none', color: theme.palette.primary.main, cursor: 'pointer' }}>Log in</span>
      </Typography>
    </Fragment>
  )
}

export const NeedHelp = () => {
  const theme = useTheme();
  return (
    <Typography textAlign={'center'}>Need help? <a style={{ color: theme.palette.primary.main, fontWeight: 600, textDecoration: 'none' }} href="/contact-us" target="_blank">Contact Us</a></Typography>
  )
}